import { useContext, useEffect, useState } from 'react';
import { HomeContext } from '../../contexts/contexHome';
import { useParams } from 'react-router-dom';
import { apiJalles } from '../../services/api';
import { FaCloudSun } from 'react-icons/fa';
import { UnitStyled } from '../../styles/home';
import { Header, Header2 } from '../../components/header';
import { SquareLoading } from '../../components/loaders';
import LogoJalles from '../../assets/logos/Jales_Nova.png';
import { SiPivotaltracker } from 'react-icons/si';
import imgPump from '../../assets/icons/pumpWite.png';
import imgTanque from '../../assets/icons/tanquesWhite.png';
import imgTanqueVinhaca from '../../assets/icons/Novotanque.png';
import imgAgua from '../../assets/icons/aguaBranca.png';
import imgAguaSuja from '../../assets/icons/aguaSujaIcon.png';
import iaAClS from '../../assets/icons/ia.png';
import { TbEngine } from 'react-icons/tb';
import { FaCow } from 'react-icons/fa6';
import { ModalHeader } from '../../styles/header';
import { HeaderMobile } from '../../components/mobileHeader';

export const Unidades = () => {
  const { navigate, isOpen, setIsOpen, modalAvisoOpen, setModalAvisoOpen, headerApi } =
    useContext(HomeContext);

  const [loading, setloading] = useState(false);
  const [Unidades, setUnidades] = useState({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const unityExists = sessionStorage.getItem('connectionsUnit');

  const ListUnidade = [
    {
      titulo: 'Pivô',
      status: true,
      navigate: `/${unityExists}/Painelpivos/Map`,
      img: <SiPivotaltracker className="icon" />,
      icon: true,
    },
    {
      titulo: 'Tanques de vinhaça',
      status: true,
      navigate: `/${unityExists}/tanques`,
      img: imgTanqueVinhaca,
      icon: false,
    },
    {
      titulo: 'Estações Meteorológicas',
      status: true,
      navigate: `/${unityExists}/clima`,
      img: <FaCloudSun className="icon" />,
      icon: true,
    },
    {
      titulo: 'Motobombas',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgPump,
      icon: false,
    },
    {
      titulo: 'Eletrobombas',
      status: false,
      navigate: `/${unityExists}/`,
      icon: true,
      img: <TbEngine className="icon" />,
    },
    {
      titulo: 'Reservatório de Água Limpa',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgAgua,
      icon: false,
    },
    {
      titulo: 'Reservatório de Água Suja',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgAguaSuja,
      icon: false,
    },
    {
      titulo: 'Biodigestor',
      status: false,
      navigate: `/${unityExists}/`,
      icon: true,
      img: <FaCow className="icon" />,
    },
    {
      titulo: 'Acls IA',
      status: false,
      navigate: `/${unityExists}/AclsIA`,
      icon: false,
      img: iaAClS,
    },
  ];

  const { unidade } = useParams();

  useEffect(() => {
    const unityExists = sessionStorage.getItem('connectionsUnit');
    if (unityExists !== unidade) {
      navigate('/');
    }
    ListUnidades();
  }, [navigate, unidade]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open'); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove('modal-open'); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  const ListUnidades = async () => {
    setloading(true);
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const response = await apiJalles.get(`unidade/Leitura/${idUnidade}`, headerApi);

      setUnidades(response.data);
      let locUnidade = {
        lat: response.data.latitude,
        long: response.data.longitude,
      };
      sessionStorage.setItem('connectionsUnitIdloc', JSON.stringify(locUnidade));
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const unidadesComStatus = ListUnidade.map((list, index) => {
    const aplicacaoContratada =
      Unidades && Unidades.aplicacoes && Unidades.aplicacoes[index] === true;

    return {
      ...list,
      aplicacaoContratada, // Adiciona o status de habilitação
    };
  });

  // Ordena com habilitados primeiro
  const sortedList = unidadesComStatus.sort((a, b) => {
    return (b.aplicacaoContratada ? 1 : 0) - (a.aplicacaoContratada ? 1 : 0);
  });

  return (
    <UnitStyled>
      {/* <Header /> */}
      <Header2 />
      <HeaderMobile />
      {loading && <SquareLoading />}
      {isOpen ? <ModalHeader onClick={() => setIsOpen(!isOpen)} /> : null}
      <div className="HeaderHome">
        {/* <div className="Logo">
          <img src={LogoJalles} alt="" />
        </div> */}
        <h2>{Unidades.name}</h2>
        <div>
          <button
            onClick={() => {
              sessionStorage.removeItem('connectionsUnit');
              navigate('/');
            }}
          >
            Trocar Unidade
          </button>
        </div>
      </div>
      <div className="listUnidades">
        <ul>
          {sortedList.map((list, index) => (
            <li
              onClick={() => {
                if (list.aplicacaoContratada) {
                  navigate(list.navigate);
                } else {
                  setModalAvisoOpen(!modalAvisoOpen);
                }
              }}
              className={list.aplicacaoContratada ? '' : 'listDesativat'}
              key={index}
            >
              <h3>{list.titulo}</h3>
              {list.icon ? list.img : <img src={list.img} alt="" />}
              <span>{list.aplicacaoContratada ? 'Contratado' : 'Não Contratado'}</span>
            </li>
          ))}
        </ul>
      </div>
    </UnitStyled>
  );
};
